import { useEffect, useRef } from "react";
import useHorizontalScrolling from "../../hooks/useHorizontalScrolling";
import { useDispatch } from "react-redux";
import { activateResumeLink, setActiveProject } from "../../store";
import Footer from "./Footer";
import TopNav from "./TopNav";
import AboutSection from "./AboutSection";
import WorksSection from "./WorksSection";
import TimelineSection from "./TimelineSection";
import ContactSection from "./ContactSection";
import Notification from "./Notification";

import "./landscape-layout.css";

function LandscapeLayout() {
  const ref = useRef();
  const aboutRef = useRef(null);
  const worksRef = useRef(null);
  const experienceRef = useRef(null);
  const contactRef = useRef(null);
  const preventIntersectionObserver = useRef(false);
  const handleScroll = useHorizontalScrolling(ref, "instant", 0.9);
  const dispatch = useDispatch();
  useEffect(() => {
    const keyUpHandler = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        dispatch(setActiveProject(null));
      }
    };

    document.addEventListener("keyup", keyUpHandler);

    return () => {
      document.removeEventListener("keyup", keyUpHandler);
    };
  }, [dispatch]);

  setTimeout(() => {
    dispatch(activateResumeLink());
  }, 15000);

  return (
    <div
      ref={ref}
      onWheel={(e) => {
        handleScroll(e);
      }}
      className="w-full h-full head-scroll"
    >
      <div className="h-full w-max flex flex-row">
        <div className="h-full w-max flex flex-col">
          <TopNav
            aboutRef={aboutRef}
            worksRef={worksRef}
            experienceRef={experienceRef}
            contactRef={contactRef}
            preventIntersectionObserver={preventIntersectionObserver}
          />
          <Notification />
          <div className="w-max grow flex flex-row">
            <AboutSection
              ref={aboutRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
            <WorksSection
              ref={worksRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
            <TimelineSection
              ref={experienceRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
            <ContactSection
              ref={contactRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default LandscapeLayout;
